import React from 'react';

const AdvertiseData = ({advertise}) => {

    const {image, name, price, description} = advertise;

    return (
        <div>
            <div className="card card-compact w-96 bg-indigo-500 shadow-xl text-white">
            <figure>
            <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
            {/* <div className="h-96 w-72"> */}
           <img src={image} style={{height:"200px", width:"400px"}} className="w-full h-full object-cover group-hover:rotate-6 group-hover:scale-150 transition:transform duration-500" alt="img" />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center px-9 text-center translate-y-[45%] group-hover:translate-y-0 transition-all">
                {/* <h1 className='text-white'>Name: {name}</h1>
                <p className='text-lg italic text-white mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300'> 
                {description}
                </p> */}
                {/* <p className='text-lg italic text-white mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300'> 
                Price: {price}
                </p> */}
            </div>
            </div>
            </figure>
            <div className="card-body">
                <div className='flex justify-between'>
                <h2 className="card-title">Car : {name}</h2>
                <h2 className="card-title">Price: {price}</h2>
                </div>
                <p>{description}</p> 
            </div>
            </div>
        </div>
    );
};

export default AdvertiseData;